import { useState } from 'react';
import { qd, apiError } from '../api';
import { useQdAuth } from '../QdApp';

export default function QdLogin() {
  const { login } = useQdAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      const { data } = await qd.post('/auth/login', { email, password });
      login(data.token, data.user);
    } catch (err) {
      setError(apiError(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#14233F] flex items-center justify-center px-4 qd-app">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded p-8 shadow-2xl">
        <p className="font-bold text-xl text-[#14233F] tracking-tight">0g Baltics</p>
        <p className="text-[11px] uppercase tracking-widest text-[#0F7D70] mb-6">Quote &amp; Documentation</p>
        <label className="block text-xs font-medium text-slate-600 mb-1" htmlFor="qd-email">Email</label>
        <input id="qd-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          className="w-full border border-slate-300 rounded px-3 py-2.5 text-sm mb-4" data-testid="qd-login-email" />
        <label className="block text-xs font-medium text-slate-600 mb-1" htmlFor="qd-password">Password</label>
        <input id="qd-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
          className="w-full border border-slate-300 rounded px-3 py-2.5 text-sm mb-5" data-testid="qd-login-password" />
        {error && <p className="text-sm text-red-600 mb-4" data-testid="qd-login-error">{error}</p>}
        <button type="submit" disabled={busy}
          className="w-full bg-[#0F7D70] hover:bg-teal-700 text-white font-semibold py-2.5 rounded text-sm disabled:opacity-60"
          data-testid="qd-login-submit">
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        <p className="text-[11px] text-slate-400 mt-5">Private application — authorized users only.</p>
      </form>
    </div>
  );
}
